//date 10/10/2026 
// finantial date auto thi according to date to new wale me popup diya h to manually sellect kar sake ok fir me badme vapas ye laga dunga 

//  2 file changes  first is feecollection.jsx and feeController.js ok 

import React, { useState, useEffect, useRef, useMemo } from 'react';
import {
  FaSearch, FaChevronDown, FaChevronUp, FaMoneyBillWave,
  FaTimes, FaListUl, FaUserGraduate, FaCheck, FaHistory
} from 'react-icons/fa';
import { useNavigate, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import api from '../../../utils/api';
import useColleges from '../../../utils/useColleges';
import { useAuth } from '../../../context/AuthContext';
import './FeeCollection.css';

const toTitleCase = (str) => (str || '').replace(/\w\S*/g, w => w.charAt(0).toUpperCase() + w.slice(1));

// ─── REUSABLE SEARCH DROPDOWN ─────────────────────────────────────────────
const SearchDropdown = ({ placeholder, options, value, onChange, disabled }) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const ref = useRef(null);

  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  // When value is pre-set externally, pre-fill search with selected label
  useEffect(() => {
    if (value) {
      const found = options.find(o => String(o.id) === String(value));
      if (found) setSearch(found.label);
    } else {
      setSearch('');
    }
  }, [value, options]);

  const selected = options.find(o => String(o.id) === String(value));
  const filtered = options.filter(o => o.label.toLowerCase().includes(search.toLowerCase()));

  return (
    <div className={`sfc-search-dd ${disabled ? 'sfc-disabled' : ''}`} ref={ref}>
      <div className="sfc-search-dd-box" onClick={() => !disabled && setOpen(v => !v)}>
        <span className="sfc-search-dd-text" style={{ color: selected ? '#2c3e50' : '#6c757d' }}>
          {selected ? selected.label : placeholder}
        </span>
        <FaChevronDown style={{ fontSize: '0.85rem', color: '#6c757d', transform: open ? 'rotate(180deg)' : 'none', transition: '0.2s' }} />
      </div>
      {open && (
        <div className="sfc-search-dd-list-wrap">
          <div className="sfc-search-dd-input-wrap">
            <FaSearch style={{color: '#94a3b8', fontSize: '0.85rem'}} />
            <input type="text" placeholder="Search..." value={search} onChange={e => setSearch(e.target.value)} autoFocus />
          </div>
          <ul className="sfc-search-dd-ul">
            <li onClick={() => { onChange(''); setOpen(false); setSearch(''); }}>-- Clear Selection --</li>
            {filtered.map(o => (
              <li key={o.id} className={String(o.id) === String(value) ? 'selected-li' : ''}
                onClick={() => { onChange(o.id); setOpen(false); setSearch(''); }}>
                {o.label}
              </li>
            ))}
            {filtered.length === 0 && <li className="empty-li">No results found</li>}
          </ul>
        </div>
      )}
    </div>
  );
};

// ─── MAIN COMPONENT ───────────────────────────────────────────────────────
const FeeCollection = () => {
  const { user }  = useAuth();
  const { colleges, loading: collegesLoading } = useColleges();
  const navigate  = useNavigate();
  const location  = useLocation();
  const isAdmin   = user?.role === 'admin' || (user?.colleges?.length > 0);
  const isScoped  = user?.role === 'collegeadmin' || user?.role === 'clerk';
  const basePath  = user?.role === 'collegeadmin' ? '/collegeadmin'
                  : user?.role === 'clerk' ? '/clerk'
                  : '/admin';

  const [allocations, setAllocations] = useState([]);
  const [loading, setLoading]         = useState(false);
  const [saving, setSaving]           = useState(false);
  const [banks, setBanks]             = useState([]);

  // Persist filters in sessionStorage (clears on reload, persists on navigation)
  const [searchQuery, setSearchQuery]     = useState(() => sessionStorage.getItem('feeCollection_searchQuery') || '');
  const [filterCollege, setFilterCollege] = useState(() => sessionStorage.getItem('feeCollection_filterCollege') || '');
  const [filterSession, setFilterSession] = useState(() => sessionStorage.getItem('feeCollection_filterSession') || '');
  const [filterBatch, setFilterBatch]     = useState(() => sessionStorage.getItem('feeCollection_filterBatch') || '');
  const [filterClass, setFilterClass]     = useState(() => sessionStorage.getItem('feeCollection_filterClass') || '');
  const [filterMedium, setFilterMedium]   = useState(() => sessionStorage.getItem('feeCollection_filterMedium') || '');
  const [filterStatus, setFilterStatus]   = useState(() => {
    const saved = sessionStorage.getItem('feeCollection_filterStatus');
    return saved !== null ? saved : 'unpaid';
  });

  const [showAddForm, setShowAddForm] = useState(false);
  const [expandedRow, setExpandedRow] = useState(null);

  // Save filters to sessionStorage whenever they change
  useEffect(() => {
    sessionStorage.setItem('feeCollection_searchQuery', searchQuery);
  }, [searchQuery]);
  
  useEffect(() => {
    sessionStorage.setItem('feeCollection_filterCollege', filterCollege);
  }, [filterCollege]);
  
  useEffect(() => {
    sessionStorage.setItem('feeCollection_filterSession', filterSession);
  }, [filterSession]);
  
  useEffect(() => {
    sessionStorage.setItem('feeCollection_filterBatch', filterBatch);
  }, [filterBatch]);
  
  useEffect(() => {
    sessionStorage.setItem('feeCollection_filterClass', filterClass);
  }, [filterClass]);

  useEffect(() => {
    sessionStorage.setItem('feeCollection_filterMedium', filterMedium);
  }, [filterMedium]);
  
  useEffect(() => {
    sessionStorage.setItem('feeCollection_filterStatus', filterStatus);
  }, [filterStatus]);

  const [formCollege, setFormCollege] = useState('');
  const [formSession, setFormSession] = useState('');
  const [formBatch, setFormBatch]     = useState('');
  const [formClass, setFormClass]     = useState('');
  const [formStudent, setFormStudent] = useState('');
  const [formFeeId, setFormFeeId]     = useState('');
  
  const [isEditingItems, setIsEditingItems]                 = useState(false);
  const [editableItems, setEditableItems]                   = useState([]);
  const [editNarration, setEditNarration]                   = useState('');
  const [isAddingParticular, setIsAddingParticular]         = useState(false);
  const [newParticulars, setNewParticulars]                 = useState([{ name: '', amount: '' }]);
  const [addParticularNarration, setAddParticularNarration] = useState('');
  const [customItems, setCustomItems]                       = useState([]);

  const [payingItems, setPayingItems]   = useState({});
  const [lateFeeCharged, setLateFeeCharged] = useState(0); 
  const [paymentModes, setPaymentModes] = useState([{ id: Date.now(), amount: '', mode: 'Cash', referenceNo: '', date: new Date().toISOString().split('T')[0] }]);
  const [lateFeeInput, setLateFeeInput] = useState('');
  const [isLateFeeEditMode, setIsLateFeeEditMode] = useState(false);
  const [narration, setNarration]       = useState('');

  const loadBanks = async () => {
    try {
      const { data } = await api.get('/banks', { params: { limit: 1000 } });
      setBanks(data.data || []);
    } catch {
      setBanks([]);
    }
  };

  useEffect(() => { loadBanks(); }, []);

  useEffect(() => {
    if (!isAdmin && colleges.length > 0) {
      setFilterCollege(String(colleges[0]._id));
      setFormCollege(String(colleges[0]._id));
    } else if (isAdmin && colleges.length === 1) {
      setFilterCollege(String(colleges[0]._id));
      setFormCollege(String(colleges[0]._id));
    }
  }, [isAdmin, colleges]);

  const loadAllocations = async () => {
    setLoading(true);
    try {
      const { data } = await api.get('/fees/allocations', { params: { limit: 1000 } });
      setAllocations(data.data || []);
    } catch {
      setAllocations([]);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { loadAllocations(); }, []);

  // Auto-open form when navigated from TotalDueList with pre-selected student/fee
  useEffect(() => {
    const state = location.state;
    if (!state?.preSelectStudentId || allocations.length === 0) return;

    // Find any allocation for this student to get college/session/batch/class
    const studentAlloc = allocations.find(a => String(a.student?._id || a.student) === String(state.preSelectStudentId));
    if (studentAlloc) {
      const cid = String(studentAlloc.college?._id || studentAlloc.college || '');
      setFormCollege(cid);
      setFormSession(studentAlloc.session || '');
      setFormBatch(studentAlloc.batch || '');
      setFormClass(studentAlloc.class || '');
      // Pre-fill search with admission number so table filters to this student
      if (studentAlloc.student?.admissionNo) setSearchQuery(studentAlloc.student.admissionNo);
    }

    setFormStudent(String(state.preSelectStudentId));
    if (state.preSelectFeeId) setFormFeeId(String(state.preSelectFeeId));
    setShowAddForm(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
    window.history.replaceState({}, '');
  }, [location.state, allocations]); // eslint-disable-line

  const pendingAllocations = useMemo(() => {
    let list = allocations.filter(a => {
      const baseFeeBalance = (a.dueAmount || 0) > 0;
      const lateFeeBalance = (a.lateFeeBalance || 0) > 0 || (a.effectiveLateFeeBalance || 0) > 0;
      const totalRemaining = (a.totalRemaining || 0) > 0;
      return baseFeeBalance || lateFeeBalance || totalRemaining;
    });
    if (formCollege) list = list.filter(a => String(a.college?._id || a.college) === formCollege);
    return list;
  }, [allocations, formCollege]);

  const formSessionOptions = useMemo(() => [...new Set(pendingAllocations.map(a => a.session).filter(Boolean))].sort().map(s => ({ id: s, label: s })), [pendingAllocations]);
  const formBatchOptions = useMemo(() => {
    let list = pendingAllocations;
    if (formSession) list = list.filter(a => a.session === formSession);
    return [...new Set(list.map(a => a.batch).filter(Boolean))].sort().map(b => ({ id: b, label: b }));
  }, [pendingAllocations, formSession]);
  const formClassOptions = useMemo(() => {
    let list = pendingAllocations;
    if (formSession) list = list.filter(a => a.session === formSession);
    if (formBatch) list = list.filter(a => a.batch === formBatch);
    return [...new Set(list.map(a => a.class).filter(Boolean))].sort().map(c => ({ id: c, label: c }));
  }, [pendingAllocations, formSession, formBatch]);
  const formStudentOptions = useMemo(() => {
    let list = pendingAllocations;
    if (formSession) list = list.filter(a => a.session === formSession);
    if (formBatch) list = list.filter(a => a.batch === formBatch);
    if (formClass) list = list.filter(a => a.class === formClass);
    const uniqueStudents = [];
    const seen = new Set();
    list.forEach(a => {
      const sId = String(a.student?._id || a.student);
      if (!seen.has(sId)) {
        seen.add(sId);
        uniqueStudents.push({ id: sId, label: `${a.student?.name || 'Unknown'} (${a.student?.admissionNo || 'N/A'})` });
      }
    });
    return uniqueStudents;
  }, [pendingAllocations, formSession, formBatch, formClass]);

  useEffect(() => {
    if (formStudent) {
      const studentAlloc = pendingAllocations.find(a => String(a.student?._id || a.student) === formStudent);
      if (studentAlloc) {
        setFormSession(studentAlloc.session || '');
        setFormBatch(studentAlloc.batch || '');
        setFormClass(studentAlloc.class || '');
      }
    }
  }, [formStudent, pendingAllocations]);

  const formFeeOptions = useMemo(() => {
    if (!formStudent) return [];
    return pendingAllocations
      .filter(a => String(a.student?._id || a.student) === formStudent)
      .map(a => ({ id: a._id, label: `${toTitleCase(a.feeName) || 'Fee'} (Due: ₹${a.dueAmount})` }));
  }, [pendingAllocations, formStudent]);

  const selectedFeeDetails = useMemo(() => {
    return pendingAllocations.find(a => String(a._id) === formFeeId) || null;
  }, [formFeeId, pendingAllocations]);

  useEffect(() => {
    if (!formFeeId || !selectedFeeDetails) return;
    const initPaying = {};
    selectedFeeDetails.items?.forEach(item => {
      if (item.balance > 0) initPaying[item.type] = '';
    });
    
    // Auto-fill total late fee into lateFeeCharged using the perfectly mapped property
    const totalLateFeeAssigned = selectedFeeDetails.lateFee || selectedFeeDetails.autoLateFee || 0;

    if (totalLateFeeAssigned > (selectedFeeDetails.lateFeesPaid || 0)) {
      initPaying['Late Fee'] = '';
    }
    
    setLateFeeCharged(totalLateFeeAssigned);
    setLateFeeInput(String(totalLateFeeAssigned));
    setIsLateFeeEditMode(false);
    
    setPayingItems(initPaying);
    setPaymentModes([{ id: Date.now(), amount: '', mode: 'Cash', bank: '', date: new Date().toISOString().split('T')[0] }]);
    setNarration('');
    setIsEditingItems(false);
    setEditNarration('');
    setIsAddingParticular(false);
    setNewParticulars([{ name: '', amount: '' }]);
    setAddParticularNarration('');
    setCustomItems([]);
  }, [formFeeId, selectedFeeDetails]);

  const handleItemPayChange = (type, val, maxBalance) => {
    // Allow empty string or valid numbers only
    if (val === '') {
      setPayingItems(prev => ({ ...prev, [type]: '' }));
      return;
    }
    
    // Remove any non-numeric characters except decimal point
    const cleaned = val.replace(/[^0-9.]/g, '');
    
    // Prevent multiple decimal points
    const parts = cleaned.split('.');
    let numStr = parts[0];
    if (parts.length > 1) {
      numStr = parts[0] + '.' + parts.slice(1).join('');
    }
    
    // If valid number, apply max limit
    if (numStr !== '' && !isNaN(numStr)) {
      let num = Number(numStr);
      if (num > maxBalance) num = maxBalance;
      if (num < 0) num = 0;
      numStr = String(num);
    }
    
    setPayingItems(prev => {
      const updated = { ...prev, [type]: numStr };
      // Recalculate if base fee is still fully paid after this change
      const baseFeeItems = selectedFeeDetails?.items || [];
      const regularPaying = baseFeeItems.reduce((sum, i) => sum + (Number(i.type === type ? numStr : updated[i.type]) || 0), 0);
      const baseFeeTotal = baseFeeItems.reduce((sum, i) => sum + (i.balance || 0), 0);
      if (regularPaying < baseFeeTotal) delete updated['Late Fee'];
      return updated;
    });
  };

  const totalPayingAmount = useMemo(() => {
    const regular = Object.values(payingItems).reduce((sum, val) => sum + (Number(val) || 0), 0);
    const custom  = customItems.reduce((sum, c) => sum + (Number(c.amount) || 0), 0);
    return regular + custom;
  }, [payingItems, customItems]);

  const handleUpdateLateFeeRow = () => {
    // Clean and validate input
    const cleaned = lateFeeInput.replace(/[^0-9.]/g, '');
    const amt = cleaned === '' ? 0 : Number(cleaned) || 0;
    const alreadyPaid = selectedFeeDetails?.lateFeesPaid || 0;

    if (amt < alreadyPaid) {
      Swal.fire('Invalid Amount', `Late fee cannot be less than the amount already paid (₹${alreadyPaid})`, 'warning');
      setLateFeeInput(String(lateFeeCharged));
      return;
    }

    if (amt !== (selectedFeeDetails?.lateFee || 0) && !narration.trim()) {
      Swal.fire('Reason Required', 'Please provide a reason for editing the late fee in the Narration field.', 'warning');
      return;
    }
    setLateFeeCharged(amt);
    setIsLateFeeEditMode(false);

    setPayingItems(prev => {
      let currentPaying = Number(prev['Late Fee']) || 0;
      const maxAllowed = amt - alreadyPaid;
      if (currentPaying > maxAllowed) currentPaying = maxAllowed;
      
      const newItems = { ...prev };
      if (maxAllowed > 0) {
        newItems['Late Fee'] = currentPaying > 0 ? String(currentPaying) : '';
      } else {
        delete newItems['Late Fee'];
      }
      return newItems;
    });
  };

  const totalPaymentModeAmount = useMemo(() => {
    return paymentModes.reduce((sum, p) => sum + (Number(p.amount) || 0), 0);
  }, [paymentModes]);

  const handleEditItemsClick = () => {
    setEditableItems(JSON.parse(JSON.stringify(selectedFeeDetails.items)));
    setEditNarration('');
    setIsEditingItems(true);
  };

  const handleSaveItemsClick = async () => {
    let hasChanges = false;
    for (const item of editableItems) {
      const originalItem = selectedFeeDetails.items.find(orig => orig.type === item.type);
      if (originalItem && Number(item.amount) !== Number(originalItem.amount)) {
        hasChanges = true;
        break;
      }
    }
    
    if (hasChanges && !editNarration.trim()) {
      Swal.fire('Reason Required', 'Please provide a reason for changing the fee amounts.', 'warning');
      return;
    }
    
    for (const item of editableItems) {
      const newAmt = Number(item.amount) || 0;
      const paid   = Number(item.amountPaid) || 0;
      if (newAmt < paid) {
        Swal.fire('Invalid Amount', `${item.type}: new amount (₹${newAmt}) cannot be less than already paid (₹${paid})`, 'warning');
        return;
      }
    }
    const updatedItems = editableItems.map(item => {
      const newTotal   = Number(item.amount) || 0;
      const newBalance = Math.max(0, newTotal - (Number(item.amountPaid) || 0));
      return { ...item, amount: newTotal, balance: newBalance };
    });
    try {
      await api.put(`/fees/allocations/${formFeeId}`, { items: updatedItems, narration: editNarration.trim() });
      await loadAllocations();
      setIsEditingItems(false);
      setEditNarration('');
      Swal.fire({ title: 'Saved!', text: "Fee amounts updated successfully.", icon: 'success', timer: 1500, showConfirmButton: false });
    } catch {
      Swal.fire('Error', 'Failed to update fee amounts.', 'error');
    }
  };

  const handleSaveNewParticulars = async () => {
    const valid = newParticulars.filter(p => p.name.trim() && Number(p.amount) > 0);
    if (valid.length === 0) {
      Swal.fire('Missing Info', 'Please enter at least one particular name and amount greater than 0.', 'warning');
      return;
    }
    const mergedItems = selectedFeeDetails.items.map(i => ({ type: i.type, amount: i.amount, amountPaid: i.amountPaid, balance: i.balance }));
    for (const p of valid) {
      const existing = mergedItems.find(i => i.type.toLowerCase() === p.name.trim().toLowerCase());
      if (existing) {
        existing.amount  = (existing.amount || 0) + Number(p.amount);
        existing.balance = Math.max(0, existing.amount - (existing.amountPaid || 0));
      } else {
        mergedItems.push({ type: p.name.trim(), amount: Number(p.amount), amountPaid: 0, balance: Number(p.amount) });
      }
    }
    try {
      await api.put(`/fees/allocations/${formFeeId}`, { items: mergedItems, narration: addParticularNarration.trim() });
      await loadAllocations();
      setIsAddingParticular(false);
      setNewParticulars([{ name: '', amount: '' }]);
      setAddParticularNarration('');
      Swal.fire({ title: 'Added!', text: 'Particular(s) added successfully.', icon: 'success', timer: 1500, showConfirmButton: false });
    } catch {
      Swal.fire('Error', 'Failed to add particular.', 'error');
    }
  };

  // Re-clamp payment mode amounts if totalPayingAmount drops below current mode total
  useEffect(() => {
    if (totalPaymentModeAmount <= totalPayingAmount) return;
    let remaining = totalPayingAmount;
    setPaymentModes(prev => prev.map(p => {
      const amt = Math.min(Number(p.amount) || 0, remaining);
      remaining = Math.max(0, remaining - amt);
      return { ...p, amount: String(amt) };
    }));
  }, [totalPayingAmount]); // eslint-disable-line

  const handleAddPaymentMode = () => setPaymentModes([...paymentModes, { id: Date.now(), amount: '', mode: 'Cash', bank: '', date: new Date().toISOString().split('T')[0] }]);
  const handleRemovePaymentMode = (id) => setPaymentModes(paymentModes.filter(p => p.id !== id));
  const handlePaymentModeChange = (id, field, value) => {
    if (field === 'amount') {
      // Clean input - remove non-numeric characters except decimal point
      const cleaned = value.replace(/[^0-9.]/g, '');
      
      const newModes = paymentModes.map(p => p.id === id ? { ...p, amount: cleaned } : p);
      const otherTotal = newModes.filter(p => p.id !== id).reduce((s, p) => s + (Number(p.amount) || 0), 0);
      const max = Math.max(0, totalPayingAmount - otherTotal);
      const numValue = Number(cleaned) || 0;
      const clamped = Math.min(numValue, max);
      setPaymentModes(paymentModes.map(p => p.id === id ? { ...p, amount: String(clamped) } : p));
      return;
    }
    // Reset bank when switching to Cash
    if (field === 'mode' && value === 'Cash') {
      setPaymentModes(paymentModes.map(p => p.id === id ? { ...p, mode: value, bank: '' } : p));
      return;
    }
    setPaymentModes(paymentModes.map(p => p.id === id ? { ...p, [field]: value } : p));
  };

  const resetForm = () => {
    setFormCollege(colleges.length === 1 ? colleges[0]._id : (isScoped ? filterCollege : ''));
    setFormSession(''); setFormBatch(''); setFormClass(''); setFormStudent(''); setFormFeeId('');
    setPayingItems({}); setPaymentModes([{ id: Date.now(), amount: '', mode: 'Cash', bank: '', date: new Date().toISOString().split('T')[0] }]);
    setLateFeeInput(''); setLateFeeCharged(0); setIsLateFeeEditMode(false); setNarration('');
    setIsEditingItems(false); setEditNarration('');
    setIsAddingParticular(false); setNewParticulars([{ name: '', amount: '' }]); setAddParticularNarration('');
    setCustomItems([]);
    setShowAddForm(false);
  };

  const handleCollectClick = (allocId) => {
    const alloc = pendingAllocations.find(a => a._id === allocId);
    if (!alloc) return;
    setFormCollege(alloc.college?._id || alloc.college || '');
    setFormSession(alloc.session || '');
    setFormBatch(alloc.batch || '');
    setFormClass(alloc.class || '');
    setFormStudent(String(alloc.student?._id || alloc.student));
    setFormFeeId(alloc._id);
    setShowAddForm(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // ── Transport cancellation info (display only — no fee calculation) ──
  const transportCancelInfo = useMemo(() => {
    if (!selectedFeeDetails?.isTransport || !selectedFeeDetails?.transportCancelled) return null;
    const join   = selectedFeeDetails.transportJoinDate   ? new Date(selectedFeeDetails.transportJoinDate)   : null;
    const end    = selectedFeeDetails.transportEndDate    ? new Date(selectedFeeDetails.transportEndDate)    : null;
    const cancel = selectedFeeDetails.transportCancelDate ? new Date(selectedFeeDetails.transportCancelDate) : null;
    if (!join || !cancel) return null;
    const msPerDay = 1000 * 60 * 60 * 24;
    const usedDays = Math.ceil((cancel - join) / msPerDay);
    const months   = Math.floor(usedDays / 30);
    const days     = usedDays % 30;
    return { join, end, cancel, usedDays, months, days };
  }, [selectedFeeDetails]);

  // Dynamic conditions for Waiver vs Payment
  const isLateFeeChanged = selectedFeeDetails && (lateFeeCharged !== (selectedFeeDetails.lateFee || selectedFeeDetails.autoLateFee || 0));
  // Base fee fully paid = already paid OR paying full balance right now
  const regularPayingNow = totalPayingAmount - (Number(payingItems['Late Fee']) || 0);
  const baseFeeBalance   = selectedFeeDetails ? Math.max(0, (selectedFeeDetails.totalAmount || 0) - (selectedFeeDetails.paidAmount || 0)) : 0;
  const isBaseFeePaid    = selectedFeeDetails && (baseFeeBalance === 0 || regularPayingNow >= baseFeeBalance);
  // Waive only when: late fee changed + base fee fully paid + zero payment entered
  const isZeroPaymentAdjustment = totalPayingAmount === 0 && isLateFeeChanged && (selectedFeeDetails?.paidAmount || 0) >= (selectedFeeDetails?.totalAmount || 0);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formStudent || !formFeeId) return Swal.fire('Missing', 'Select student and fee.', 'warning');
    
    if (totalPayingAmount <= 0 && !isLateFeeChanged) {
      return Swal.fire('Invalid Amount', 'Please enter a valid paying amount or adjust the late fee.', 'warning');
    }

    if (isLateFeeChanged && !narration.trim()) {
      return Swal.fire('Reason Required', 'Please provide a reason for editing the late fee in the Narration field.', 'warning');
    }
    
    if (totalPayingAmount > 0 && totalPaymentModeAmount > totalPayingAmount) {
      return Swal.fire('Amount Mismatch', `Payment mode total (₹${totalPaymentModeAmount}) cannot exceed the paying amount (₹${totalPayingAmount}).`, 'error');
    }

    if (totalPayingAmount > 0 && totalPaymentModeAmount !== totalPayingAmount) {
      return Swal.fire('Amount Mismatch', `The Total Paying Amount (₹ ${totalPayingAmount}) must exactly match the total in Payment Modes (₹ ${totalPaymentModeAmount}).`, 'error');
    }

    // Validate payment modes
    for (const pm of paymentModes) {
      if (Number(pm.amount) > 0 && pm.mode !== 'Cash') {
        // Bank is mandatory for non-cash modes
        if (!pm.bank) {
          return Swal.fire('Bank Required', `Please select a credited bank for ${pm.mode} payment mode.`, 'warning');
        }
        // Reference/Transaction number is mandatory for non-cash modes
        if (!pm.referenceNo || !pm.referenceNo.trim()) {
          return Swal.fire('Reference No Required', `Please enter a Reference/Transaction Number for ${pm.mode} payment mode.`, 'warning');
        }
      }
    }

    // ── Pre-Payment Confirmation Dialog ──
    const student = selectedFeeDetails?.student;
    const isWaiver = isZeroPaymentAdjustment;
    
    const selectedReceiptDate = new Date().toISOString().split('T')[0];
    const allModeDates = paymentModes.map(p => p.date).filter(Boolean);
    const selectedPaymentDate = allModeDates.length > 0
      ? allModeDates.reduce((earliest, d) => d < earliest ? d : earliest)
      : selectedReceiptDate;

    const confirmHtml = `
      <div style="text-align: left; font-family: system-ui, -apple-system, sans-serif; font-size: 14px; color: #334155; line-height: 1.5;">
        <p style="margin: 0 0 12px 0; font-weight: 700; color: #1e293b; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; font-size: 15px;">
          Review Details Before Saving:
        </p>
        <table style="width: 100%; border-collapse: collapse; margin-bottom: 16px;">
          <tbody>
            <tr style="border-bottom: 1px solid #f1f5f9;">
              <th style="text-align: left; padding: 6px 0; color: #64748b; font-weight: 500; width: 38%;">Student Name</th>
              <td style="padding: 6px 0; font-weight: 600; color: #0f172a;">${student?.name || 'N/A'}</td>
            </tr>
            <tr style="border-bottom: 1px solid #f1f5f9;">
              <th style="text-align: left; padding: 6px 0; color: #64748b; font-weight: 500;">Father's Name</th>
              <td style="padding: 6px 0; color: #334155;">${student?.fatherName || 'N/A'}</td>
            </tr>
            <tr style="border-bottom: 1px solid #f1f5f9;">
              <th style="text-align: left; padding: 6px 0; color: #64748b; font-weight: 500;">Admission No</th>
              <td style="padding: 6px 0; color: #334155;">${student?.admissionNo || 'N/A'}</td>
            </tr>
            <tr style="border-bottom: 1px solid #f1f5f9;">
              <th style="text-align: left; padding: 6px 0; color: #64748b; font-weight: 500;">Contact No</th>
              <td style="padding: 6px 0; color: #334155;">${student?.contact || 'N/A'}</td>
            </tr>
            <tr style="border-bottom: 1px solid #f1f5f9;">
              <th style="text-align: left; padding: 6px 0; color: #64748b; font-weight: 500;">Email ID</th>
              <td style="padding: 6px 0; color: #334155; word-break: break-all;">${student?.email || 'N/A'}</td>
            </tr>

            <tr style="background-color: #f8fafc; border-top: 2px solid #cbd5e1;">
              <th style="text-align: left; padding: 12px 8px; color: #0f172a; font-weight: 700;">Total Paying</th>
              <td style="padding: 12px 8px; font-size: 18px; font-weight: 800; color: ${isWaiver ? '#64748b' : '#10b981'};">
                ₹ ${totalPayingAmount.toLocaleString('en-IN')}${isWaiver ? ' (Adjustment)' : ''}
              </td>
            </tr>
          </tbody>
        </table>
        <p style="font-size: 12px; color: #64748b; text-align: center; margin: 0; font-style: italic;">
          Are you sure you want to process this payment transaction?
        </p>
      </div>
    `;

    const confirmRes = await Swal.fire({
      title: 'Confirm Payment Collection',
      html: confirmHtml,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, Pay Now',
      cancelButtonText: 'No, Cancel',
      confirmButtonColor: '#10b981',
      cancelButtonColor: '#64748b',
    });

    if (!confirmRes.isConfirmed) return;


    setSaving(true);
    try {
      const itemsToPay = [
        ...Object.entries(payingItems)
          .filter(([_, amt]) => Number(amt) > 0)
          .map(([type, amt]) => ({ type, amountPaid: Number(amt) })),
        ...customItems
          .filter(c => c.name.trim() && Number(c.amount) > 0)
          .map(c => ({ type: c.name.trim(), amountPaid: Number(c.amount) })),
      ];

      const lateFeeItem = itemsToPay.find(i => i.type === 'Late Fee');
      const effectiveLateFee = lateFeeItem ? lateFeeItem.amountPaid : 0;
      
      const payload = {
        paymentId: formFeeId,
        itemPayments: itemsToPay,
        lateFeeCharged: lateFeeCharged,
        autoCalculatedLateFee: selectedFeeDetails?.autoLateFee || selectedFeeDetails?.lateFee || 0,  // Send what user saw before editing
        lateFee: effectiveLateFee,               
        discount: 0,
        narration,
        receiptDate: selectedReceiptDate,
        paymentDate: selectedPaymentDate,
        paymentModes: totalPayingAmount > 0 ? paymentModes.map(p => ({
          amount: Number(p.amount) || 0,
          mode: p.mode,
          bank: p.mode === 'Cash' ? null : (p.bank || null),
          referenceNo: p.referenceNo || '',
          date: p.date || selectedReceiptDate,
        })) : []
      };

      const { data } = await api.post('/fees/pay', payload);

      if (isZeroPaymentAdjustment) {
        Swal.fire({
          title: 'Fee Adjusted!',
          text: 'The late fee has been waived/updated successfully. No receipt generated.',
          icon: 'success',
          timer: 2500,
          showConfirmButton: false
        });
        resetForm();
        loadAllocations();
        return;
      }

      // 🔥 Check if receipt was actually generated (backend returns null if zero payment)
      if (!data.data?.txnReceiptNo) {
        Swal.fire({
          title: 'Updated!',
          text: 'Fee adjustment saved successfully. No receipt generated for zero payment.',
          icon: 'success',
          timer: 2500,
          showConfirmButton: false
        });
        resetForm();
        loadAllocations();
        return;
      }

      const collegeObj = colleges.find(c => String(c._id) === String(selectedFeeDetails.college?._id || selectedFeeDetails.college)) || selectedFeeDetails.college || {};
      const snapshotItems = itemsToPay;
      const snapshotPaid  = totalPayingAmount;
      const snapshotModes = paymentModes.filter(p => Number(p.amount) > 0).map(p => ({ 
        mode: p.mode, 
        referenceNo: p.referenceNo || '—', 
        amount: Number(p.amount) || 0, 
        date: p.date,
        bank: p.bank || null  // Include bank ID
      }));
      const txns = data.data?.transactions || [];
      const lastTxn = txns[txns.length - 1];
      const snapshotReceiptNo = data.data?.txnReceiptNo || data.data?.receiptNo || `RCP-${Date.now()}`;
      
      // 🔥 CRITICAL: Get balance from backend snapshot - NEVER calculate!
      const frozenBalance = lastTxn?.balanceAfterTransaction !== undefined 
        ? lastTxn.balanceAfterTransaction 
        : (data.data?.dueAmount || 0);
      
      // 🔥 FIX: Calculate total remaining including unpaid late fees for receipt
      const lateFeeRemaining = Math.max(0, (data.data?.lateFee || 0) - (data.data?.lateFeesPaid || 0));
      const totalRemainingForReceipt = frozenBalance + lateFeeRemaining;
      
      const snapshotAlloc = {
        college:     collegeObj,
        student:     selectedFeeDetails.student || {},
        feeName:     lastTxn?.feeName || selectedFeeDetails.feeName || 'Fee',
        session:     lastTxn?.sessionName || selectedFeeDetails.session || '',
        batch:       selectedFeeDetails.batch   || '',
        class:       lastTxn?.studentClass || selectedFeeDetails.class   || '',
        balance:     totalRemainingForReceipt,  // 🔥 Use total remaining (base + late fee)
        items:       snapshotItems.map(i => ({ type: i.type, amountPaid: Number(i.amountPaid) || 0 })),
      };

      resetForm();
      loadAllocations();

      Swal.fire({
        title: 'Payment Successful!',
        text: 'Do you want to print the receipt?',
        icon: 'success',
        showCancelButton: true,
        confirmButtonText: 'Yes, View Receipt',
        cancelButtonText: 'Close',
        confirmButtonColor: '#10b981'
      }).then((res) => {
        if (res.isConfirmed) handleViewReceipt(snapshotAlloc, snapshotPaid, snapshotItems, snapshotModes, snapshotReceiptNo, selectedReceiptDate);
      });
    } catch (err) {
      Swal.fire('Error', err.response?.data?.message || 'Payment failed.', 'error');
    } finally {
      setSaving(false);
    }
  };

  const openLog = (alloc) => {
    const collegeObj = colleges.find(c => String(c._id) === String(alloc.college?._id || alloc.college)) || alloc.college || {};
    navigate(`${basePath}/fee-collection-log`, {
      state: { allocation: { ...alloc, college: collegeObj } }
    });
  };

  const handleViewReceipt = async (alloc, newlyPaid, newItems, modesSnapshot, receiptNoOverride, receiptDateOverride) => {
    const collegeObj = colleges.find(c => String(c._id) === String(alloc.college?._id || alloc.college)) || alloc.college || {};

    // Fetch fresh student data to guarantee fatherName + currentYear
    let studentData = alloc.student || {};
    try {
      const sid = studentData._id || studentData;
      if (sid) {
        const { data } = await api.get(`/students/${sid}`);
        if (data?.data) studentData = data.data;
      }
    } catch { /* use existing */ }

    // Build receipt items
    const receiptItems = (newItems || []).map(i => ({
      type:       i.type,
      amountPaid: Number(i.amountPaid) || 0,
    }));

    // Build modes with bank information - prioritize snapshot data
    const modes = (modesSnapshot && modesSnapshot.length > 0) 
      ? modesSnapshot.map(m => {
          // If bank ID exists, fetch bank details from banks array
          const bankObj = m.bank ? banks.find(b => String(b._id) === String(m.bank)) : null;
          return {
            mode: m.mode,
            referenceNo: m.referenceNo || '—',
            amount: m.amount,
            date: m.date,
            // 🔥 Use snapshot bank details if available (from backend), otherwise fetch from banks array
            bankName: m.bankName || bankObj?.name || null,
            bankAccount: m.bankAccount || bankObj?.accountNumber || null,
            bank: bankObj ? { name: bankObj.name, accountNumber: bankObj.accountNumber } : null
          };
        })
      : [{ mode: 'Cash', referenceNo: '—', amount: newlyPaid || 0, date: new Date().toISOString().split('T')[0], bankName: null, bankAccount: null, bank: null }];

    navigate(`${basePath}/fee-receipt`, {
      state: {
        allocation: {
          college: collegeObj,
          student: studentData,
        },
        payment: {
          receiptNo:      receiptNoOverride || alloc.receiptNo || `RCPT-${Date.now()}`,
          paidAt:         receiptDateOverride || new Date().toISOString().split('T')[0],
          paidAmount:     newlyPaid || 0,
          paymentModes:   modes,
          items:          receiptItems,
          // 🔥 FROZEN SNAPSHOT DATA - from backend, never changes
          balanceAfterTransaction: alloc.balance,  // This comes from lastTxn.balanceAfterTransaction
          feeName:        alloc.feeName || 'Fee',
          studentClass:   alloc.class || 'N/A',
          sessionName:    alloc.session || 'N/A',
          itemsAtTransaction: receiptItems,
        },
      }
    });
  };

  const tableFilterOptions = useMemo(() => {
    let list = allocations;
    if (filterCollege) list = list.filter(a => String(a.college?._id || a.college) === filterCollege);
    const mediumSet = new Set();
    list.forEach(a => { const m = a.student?.class?.medium || a.student?.medium; if (m) mediumSet.add(m); });
    return {
      sessions: [...new Set(list.map(a => a.session).filter(Boolean))].sort(),
      batches:  [...new Set(list.map(a => a.batch).filter(Boolean))].sort(),
      classes:  [...new Set(list.map(a => a.class).filter(Boolean))].sort(),
      mediums:  [...mediumSet].sort(),
    };
  }, [allocations, filterCollege]);

  const getStatus = (a) => {
  if (a.dueAmount <= 0) return 'paid'; // 🔥 Fix: Balance of 0 means paid
  if (a.paidAmount > 0 && a.dueAmount > 0)  return 'partial';
  return 'pending';
};

  const displayedAllocations = useMemo(() => {
    return allocations.filter(a => {
      const q = searchQuery.toLowerCase();
      const matchSearch  = (a.student?.name || '').toLowerCase().includes(q) || (a.student?.admissionNo || '').toLowerCase().includes(q);
      const matchCollege = filterCollege ? String(a.college?._id || a.college) === filterCollege : true;
      const matchSession = filterSession ? a.session === filterSession : true;
      const matchBatch   = filterBatch ? a.batch === filterBatch : true;
      const matchClass   = filterClass  ? a.class === filterClass : true;
      const matchMedium  = filterMedium ? (a.student?.class?.medium || a.student?.medium || '') === filterMedium : true;
      const status = getStatus(a);
      const matchStatus = filterStatus === 'unpaid' ? (status === 'pending' || status === 'partial')
                        : filterStatus ? status === filterStatus
                        : true;
      return matchSearch && matchCollege && matchSession && matchBatch && matchClass && matchMedium && matchStatus;
    });
  }, [allocations, searchQuery, filterCollege, filterSession, filterBatch, filterClass, filterMedium, filterStatus]);

  const groupedAllocations = useMemo(() => {
    const g = {};
    displayedAllocations.forEach(a => {
      const key = a.college?.name || colleges.find(c => String(c._id) === String(a.college?._id || a.college))?.name || 'Unassigned';
      if (!g[key]) g[key] = [];
      g[key].push(a);
    });
    return g;
  }, [displayedAllocations, colleges]);

  const getStatusHtml = (due, paid) => {
  if (due <= 0) return <span className="sfc-badge sfc-badge-clear">Paid</span>; // 🔥 Fix: Render Paid badge on 0 due
  if (paid > 0 && due > 0)  return <span className="sfc-badge sfc-badge-partial">Partial</span>;
  return <span className="sfc-badge sfc-badge-unpaid">Pending</span>;
};

  return (
    <div className="sfc-container">
      <h2 className="sfc-title">Fee Collection</h2>

      {/* ── Top Controls ── */}
      <div className="sfc-controls">
        <div className="sfc-search-wrapper">
          <FaSearch className="sfc-search-icon" />
          <input type="text" className="sfc-search-input" placeholder="Search student or adm no..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} />
          {searchQuery && <button className="sfc-search-clear" onClick={() => setSearchQuery('')}><FaTimes /></button>}
        </div>

        {!isScoped && colleges.length > 1 && (
          <select className="sfc-filter-select" value={filterCollege} onChange={e => { setFilterCollege(e.target.value); setFilterSession(''); setFilterBatch(''); setFilterClass(''); }}>
            <option value="">All Colleges</option>
            {colleges.map(c => <option key={c._id} value={c._id}>{c.name}</option>)}
          </select>
        )}

        <select className="sfc-filter-select" value={filterSession} onChange={e => setFilterSession(e.target.value)}>
          <option value="">All Sessions</option>
          {tableFilterOptions.sessions.map(s => <option key={s} value={s}>{s}</option>)}
        </select>
        <select className="sfc-filter-select" value={filterBatch} onChange={e => setFilterBatch(e.target.value)}>
          <option value="">All Batches</option>
          {tableFilterOptions.batches.map(b => <option key={b} value={b}>{b}</option>)}
        </select>
        <select className="sfc-filter-select" value={filterClass} onChange={e => setFilterClass(e.target.value)}>
          <option value="">All Classes</option>
          {tableFilterOptions.classes.map(c => <option key={c} value={c}>{c}</option>)}
        </select>
        <select className="sfc-filter-select" value={filterMedium} onChange={e => setFilterMedium(e.target.value)}>
          <option value="">All Mediums</option>
          {tableFilterOptions.mediums.map(m => <option key={m} value={m}>{m}</option>)}
        </select>

        <select className="sfc-filter-select" value={filterStatus} onChange={e => setFilterStatus(e.target.value)}>
          <option value="unpaid">Pending + Partial</option>
          <option value="">All</option>
          <option value="pending">Pending</option>
          <option value="partial">Partial</option>
          <option value="paid">Paid</option>
        </select>

        <button className="sfc-btn sfc-btn-add" onClick={() => { if (showAddForm) resetForm(); else setShowAddForm(true); }}>
          {showAddForm ? <><FaTimes /> Close Form</> : <><FaMoneyBillWave /> Collect Fee</>}
        </button>
      </div>

      {/* ── Inline Collect Fee Form ── */}
      {showAddForm && (
        <form className="sfc-inline-form" onSubmit={handleSubmit}>
          <h3 className="sfc-form-title">💳 Collect Student Fee</h3>
          
          <h4 className="sfc-section-title"><div style={{display:'flex', alignItems:'center', gap:'8px'}}><FaUserGraduate/> Student Selection</div></h4>
          <div className="sfc-form-grid">
            {isAdmin && (
              <div className="sfc-form-group">
                <label>College</label>
                <select className="sfc-input-field" value={formCollege} onChange={e => { setFormCollege(e.target.value); setFormSession(''); setFormBatch(''); setFormClass(''); setFormStudent(''); }} disabled={isScoped}>
                  <option value="">-- Select --</option>
                  {colleges.map(c => <option key={c._id} value={c._id}>{c.name}</option>)}
                </select>
              </div>
            )}
            <div className="sfc-form-group">
              <label>Session</label>
              <SearchDropdown placeholder="All Sessions" options={formSessionOptions} value={formSession} onChange={setFormSession} disabled={!formCollege} />
            </div>
            <div className="sfc-form-group">
              <label>Batch</label>
              <SearchDropdown placeholder="All Batches" options={formBatchOptions} value={formBatch} onChange={setFormBatch} disabled={!formCollege} />
            </div>
            <div className="sfc-form-group">
              <label>Class</label>
              <SearchDropdown placeholder="All Classes" options={formClassOptions} value={formClass} onChange={setFormClass} disabled={!formCollege} />
            </div>

            <div className="sfc-form-group sfc-col-span-2">
              <label>Select Student <span className="sfc-req">*</span> <span style={{fontSize:'0.75rem', color:'#64748b'}}>(Showing only students with pending fees)</span></label>
              <SearchDropdown placeholder="Type Name or Admission No..." options={formStudentOptions} value={formStudent} onChange={setFormStudent} disabled={!formCollege} />
            </div>

            {formStudent && (
              <div className="sfc-form-group sfc-col-span-2">
                <label>Pending Fee Structure <span className="sfc-req">*</span></label>
                <SearchDropdown placeholder="-- Select Pending Fee --" options={formFeeOptions} value={formFeeId} onChange={setFormFeeId} disabled={!formStudent} />
              </div>
            )}
          </div>

          {/* Particulars Payment Section */}
          {selectedFeeDetails && (
            <>
              {/* ── Transport Cancellation Info Banner ── */}
              {transportCancelInfo && (
                <div className="sfc-transport-cancel-banner">
                  <div className="sfc-tcb-header">
                    <span className="sfc-tcb-icon">🚌</span>
                    <span className="sfc-tcb-title">Transport Cancelled</span>
                    <span className="sfc-tcb-badge">Cancelled</span>
                  </div>
                  <div className="sfc-tcb-grid">
                    <div className="sfc-tcb-item">
                      <span className="sfc-tcb-label">Join Date</span>
                      <span className="sfc-tcb-val">{transportCancelInfo.join.toLocaleDateString('en-IN')}</span>
                    </div>
                    <div className="sfc-tcb-item">
                      <span className="sfc-tcb-label">Cancel Date</span>
                      <span className="sfc-tcb-val" style={{color:'#e74c3c'}}>{transportCancelInfo.cancel.toLocaleDateString('en-IN')}</span>
                    </div>
                    <div className="sfc-tcb-item">
                      <span className="sfc-tcb-label">End Date</span>
                      <span className="sfc-tcb-val">{transportCancelInfo.end ? transportCancelInfo.end.toLocaleDateString('en-IN') : '—'}</span>
                    </div>
                    <div className="sfc-tcb-item">
                      <span className="sfc-tcb-label">Duration Used</span>
                      <span className="sfc-tcb-val" style={{color:'#d97706', fontWeight:700}}>
                        {transportCancelInfo.months > 0 && `${transportCancelInfo.months} month${transportCancelInfo.months > 1 ? 's' : ''} `}
                        {transportCancelInfo.days > 0 && `${transportCancelInfo.days} day${transportCancelInfo.days > 1 ? 's' : ''}`}
                        {transportCancelInfo.months === 0 && transportCancelInfo.days === 0 && '< 1 day'}
                      </span>
                    </div>
                  </div>
                </div>
              )}
              <h4 className="sfc-section-title" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '10px' }}>
                <div style={{display:'flex', alignItems:'center', gap:'8px'}}><FaListUl/> Fee Breakdown & Payment</div>
                <div style={{display:'flex', gap:'8px', flexWrap:'wrap'}}>
                  {/* Edit Amounts button */}
                  {!isEditingItems && !isAddingParticular && (
                    <button type="button" onClick={handleEditItemsClick} className="sfc-btn-receipt" style={{ color: '#0284c7', borderColor: '#bae6fd', background: '#eaf4ff' }}>
                      ✎ Edit Amounts
                    </button>
                  )}
                  {isEditingItems && (
                    <>
                      <button type="button" onClick={handleSaveItemsClick} className="sfc-btn-receipt" style={{ color: '#16a34a', borderColor: '#bbf7d0', background: '#dcfce7' }}><FaCheck /> Save Edits</button>
                      <button type="button" onClick={() => { setIsEditingItems(false); setEditNarration(''); }} className="sfc-btn-receipt" style={{ color: '#dc2626', borderColor: '#fecaca', background: '#fee2e2' }}><FaTimes /> Cancel</button>
                    </>
                  )}
                  {/* Add Particular button */}
                  {!isEditingItems && !isAddingParticular && (
                    <button type="button" onClick={() => { setIsAddingParticular(true); setNewParticulars([{ name: '', amount: '' }]); setAddParticularNarration(''); }} className="sfc-btn-receipt" style={{ color: '#7c3aed', borderColor: '#ddd6fe', background: '#f5f3ff' }}>
                      + Add Particular
                    </button>
                  )}
                  {isAddingParticular && (
                    <>
                      <button type="button" onClick={handleSaveNewParticulars} className="sfc-btn-receipt" style={{ color: '#16a34a', borderColor: '#bbf7d0', background: '#dcfce7' }}><FaCheck /> Save</button>
                      <button type="button" onClick={() => { setIsAddingParticular(false); setNewParticulars([{ name: '', amount: '' }]); setAddParticularNarration(''); }} className="sfc-btn-receipt" style={{ color: '#dc2626', borderColor: '#fecaca', background: '#fee2e2' }}><FaTimes /> Cancel</button>
                    </>
                  )}
                </div>
              </h4>

              {/* ── Add Particular Panel ── */}
              {isAddingParticular && (
                <div style={{ background: '#f5f3ff', border: '1px solid #ddd6fe', borderRadius: '8px', padding: '16px', marginBottom: '12px' }}>
                  <p style={{ margin: '0 0 12px', fontWeight: 700, color: '#5b21b6', fontSize: '0.88rem' }}>➕ Add New Particular(s) — only adds fee, does not pay</p>
                  {newParticulars.map((p, idx) => (
                    <div key={idx} style={{ display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '8px', flexWrap: 'wrap' }}>
                      <input
                        type="text"
                        className="sfc-input-field"
                        placeholder="Particular name (e.g. Library Fee)"
                        value={p.name}
                        onChange={e => setNewParticulars(prev => prev.map((x, i) => i === idx ? { ...x, name: e.target.value } : x))}
                        style={{ flex: 2, minWidth: '160px' }}
                      />
                      <input
                        type="number"
                        className="sfc-input-field"
                        placeholder="Amount (₹)"
                        min="1"
                        value={p.amount}
                        onChange={e => setNewParticulars(prev => prev.map((x, i) => i === idx ? { ...x, amount: e.target.value } : x))}
                        style={{ flex: 1, minWidth: '120px' }}
                      />
                      {newParticulars.length > 1 && (
                        <button type="button" onClick={() => setNewParticulars(prev => prev.filter((_, i) => i !== idx))}
                          style={{ background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: '1rem', padding: '4px' }}>
                          <FaTimes />
                        </button>
                      )}
                    </div>
                  ))}
                  <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap', marginTop: '8px' }}>
                    <button type="button" onClick={() => setNewParticulars(prev => [...prev, { name: '', amount: '' }])}
                      className="sfc-btn-receipt" style={{ color: '#7c3aed', borderColor: '#ddd6fe', background: '#ede9fe', margin: 0 }}>
                      + Add Row
                    </button>
                  </div>
                </div>
              )}

              <div className="sfc-payment-grid-wrapper">
                <table className="sfc-payment-table">
                  <thead>
                    <tr>
                      <th style={{textAlign:'left'}}>Particulars</th>
                      <th>Total Amount (₹)</th>
                      <th>Already Paid (₹)</th>
                      <th>Balance Due (₹)</th>
                      <th>{isEditingItems ? 'New Amount (₹)' : 'Paying Amount (₹)'}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isEditingItems ? (
                      editableItems.map((item, idx) => {
                        const paid        = Number(item.amountPaid) || 0;
                        const curAmt      = Number(item.amount) || 0;
                        const calcBal     = Math.max(0, curAmt - paid);
                        const isBelowPaid = curAmt < paid;
                        return (
                          <tr key={idx}>
                            <td style={{textAlign:'left', fontWeight:600}}>{item.type}</td>
                            <td>
                              <input type="number" className="sfc-input-field" value={item.amount} min={paid}
                                style={{ borderColor: isBelowPaid ? '#ef4444' : undefined }}
                                onChange={e => setEditableItems(editableItems.map((it, i) => i === idx ? { ...it, amount: e.target.value } : it))}
                              />
                              {isBelowPaid && <span style={{fontSize:'0.72rem', color:'#ef4444', display:'block', marginTop:2}}>Min: ₹{paid}</span>}
                            </td>
                            <td style={{color:'#16a34a'}}>₹ {paid}</td>
                            <td style={{color: isBelowPaid ? '#ef4444' : '#e74c3c', fontWeight:700}}>₹ {calcBal}</td>
                            <td><span style={{fontSize:'0.8rem', color:'#94a3b8'}}>Edit Mode</span></td>
                          </tr>
                        );
                      })
                    ) : (
                      <>
                        {selectedFeeDetails.items?.map(item => (
                          <tr key={item.type}>
                            <td style={{textAlign:'left', fontWeight:600}}>{item.type}</td>
                            <td>₹ {item.amount}</td>
                            <td style={{color:'#16a34a'}}>₹ {item.amountPaid}</td>
                            <td style={{color:'#e74c3c', fontWeight:700}}>₹ {item.balance}</td>
                            <td>
                              {item.balance > 0 ? (
                                <input type="text" inputMode="numeric" className="sfc-input-field sfc-amount-input"
                                  placeholder="0"
                                  value={payingItems[item.type] !== undefined ? payingItems[item.type] : ''}
                                  onKeyDown={e => {
                                    // Prevent arrow keys and non-numeric keys (except backspace, delete, tab, decimal)
                                    if (['ArrowUp','ArrowDown'].includes(e.key)) e.preventDefault();
                                    if (!/[0-9.]/.test(e.key) && !['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight'].includes(e.key)) {
                                      e.preventDefault();
                                    }
                                  }}
                                  onChange={e => handleItemPayChange(item.type, e.target.value, item.balance)}
                                />
                              ) : (
                                <span style={{color:'#16a34a', fontWeight:600, fontSize:'0.85rem'}}>✓ Cleared</span>
                              )}
                            </td>
                          </tr>
                        ))}
                        {lateFeeCharged > 0 && (
                          <tr>
                            <td style={{textAlign:'left', fontWeight:600}}>Late Fee / Fine</td>
                            <td>₹ {lateFeeCharged}</td>
                            <td style={{color:'#16a34a'}}>₹ {selectedFeeDetails.lateFeesPaid || 0}</td>
                            <td style={{color:'#e74c3c', fontWeight:700}}>₹ {Math.max(0, lateFeeCharged - (selectedFeeDetails.lateFeesPaid || 0))}</td>
                            <td>
                              {Math.max(0, lateFeeCharged - (selectedFeeDetails.lateFeesPaid || 0)) > 0 ? (
                                <input type="text" inputMode="numeric" className="sfc-input-field sfc-amount-input"
                                  placeholder="0"
                                  title={!isBaseFeePaid ? 'Please fill full base fee amount first to pay late fee' : ''}
                                  value={payingItems['Late Fee'] !== undefined ? payingItems['Late Fee'] : ''}
                                  onKeyDown={e => {
                                    if (['ArrowUp','ArrowDown'].includes(e.key)) e.preventDefault();
                                    if (!/[0-9.]/.test(e.key) && !['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight'].includes(e.key)) {
                                      e.preventDefault();
                                    }
                                  }}
                                  disabled={!isBaseFeePaid}
                                  onChange={e => {
                                    let v = Number(e.target.value);
                                    const maxAllowed = Math.max(0, lateFeeCharged - (selectedFeeDetails.lateFeesPaid || 0));
                                    if (v > maxAllowed) v = maxAllowed;
                                    if (v < 0) v = 0;
                                    setPayingItems(prev => ({...prev, 'Late Fee': String(v)}));
                                  }}
                                />
                              ) : (
                                <span style={{color:'#16a34a', fontWeight:600, fontSize:'0.85rem'}}>✓ Cleared</span>
                              )}
                            </td>
                          </tr>
                        )}
                      </>
                    )}
                  </tbody>
                </table>
              </div>

              {/* Multiple Payment Modes Structure */}
              <h4 className="sfc-section-title"><div style={{display:'flex', alignItems:'center', gap:'8px'}}><FaMoneyBillWave/> Payment Mode Details</div></h4>
              <div className="sfc-payment-grid-wrapper">
                <table className="sfc-payment-table">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Paid Amount (₹)</th>
                      <th>Payment Mode</th>
                      <th>Credited Bank {paymentModes.some(p => p.mode !== 'Cash') && <span style={{color:'#ef4444'}}>*</span>}</th>
                      <th>Reference Number {paymentModes.some(p => p.mode !== 'Cash') && <span style={{color:'#ef4444'}}>*</span>}</th>
                      <th>Date</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paymentModes.map((pm, idx) => {
                      const availableBanks = banks.filter(b => 
                        !formCollege || b.colleges?.some(c => String(c._id || c) === String(formCollege))
                      );
                      return (
                        <tr key={pm.id}>
                          <td style={{fontWeight: 700, color: '#475569'}}>{idx + 1}</td>
                          <td>
                            <input type="text" inputMode="numeric" className="sfc-input-field sfc-amount-input" value={pm.amount} 
                              onKeyDown={e => {
                                if (['ArrowUp','ArrowDown'].includes(e.key)) e.preventDefault();
                                if (!/[0-9.]/.test(e.key) && !['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight'].includes(e.key)) {
                                  e.preventDefault();
                                }
                              }} 
                              onChange={e => handlePaymentModeChange(pm.id, 'amount', e.target.value)} placeholder="0" disabled={isZeroPaymentAdjustment} />
                          </td>
                          <td>
                            <select className="sfc-input-field" value={pm.mode} onChange={e => handlePaymentModeChange(pm.id, 'mode', e.target.value)} disabled={isZeroPaymentAdjustment}>
                              <option value="Cash">Cash</option>
                              <option value="Cheque">Cheque</option>
                              <option value="UPI">UPI</option>
                              <option value="Bank Transfer">Bank Transfer</option>
                              <option value="Card">Card</option>
                              <option value="Demand Draft">Demand Draft</option>
                            </select>
                          </td>
                          <td>
                            {pm.mode === 'Cash' ? (
                              <span style={{color:'#94a3b8', fontSize:'0.85rem'}}>—</span>
                            ) : (
                              <select 
                                className="sfc-input-field" 
                                value={pm.bank || ''} 
                                onChange={e => handlePaymentModeChange(pm.id, 'bank', e.target.value)} 
                                disabled={isZeroPaymentAdjustment}
                                style={!pm.bank && Number(pm.amount) > 0 ? {borderColor: '#ef4444'} : {}}
                              >
                                <option value="">-- Select Bank --</option>
                                {availableBanks.map(b => (
                                  <option key={b._id} value={b._id}>
                                    {b.name} - {b.accountNumber}
                                  </option>
                                ))}
                              </select>
                            )}
                          </td>
                          <td>
                            {pm.mode === 'Cash' ? (
                              <span style={{color:'#94a3b8', fontSize:'0.85rem'}}>—</span>
                            ) : (
                              <input 
                                type="text" 
                                className="sfc-input-field" 
                                value={pm.referenceNo || ''} 
                                onChange={e => handlePaymentModeChange(pm.id, 'referenceNo', e.target.value)} 
                                placeholder="Ref/Txn No" 
                                disabled={isZeroPaymentAdjustment}
                                // Dynamically highlights the border red if empty and there's a payment amount
                                style={!pm.referenceNo?.trim() && Number(pm.amount) > 0 ? { borderColor: '#ef4444' } : {}}
                              />
                            )}
                          </td>
                          <td>
                            <input type="date" className="sfc-input-field" value={pm.date} onChange={e => handlePaymentModeChange(pm.id, 'date', e.target.value)} style={{minWidth:'130px'}} disabled={isZeroPaymentAdjustment} />
                          </td>
                          <td>
                            {paymentModes.length > 1 ? (
                              <button type="button" onClick={() => handleRemovePaymentMode(pm.id)} className="sfc-search-clear" style={{position:'static', transform:'none', padding:'6px'}} disabled={isZeroPaymentAdjustment}><FaTimes/></button>
                            ) : (
                              <span style={{color:'#94a3b8'}}>-</span>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan="4">
                        <button type="button" onClick={handleAddPaymentMode} className="sfc-btn-receipt" style={{margin:'0 auto'}} disabled={isZeroPaymentAdjustment}>+ Add New Mode</button>
                      </td>
                      <td style={{textAlign: 'right', fontWeight: 'bold', fontSize: '1rem'}}>Total Mode Amt:</td>
                      <td style={{fontWeight: 'bold', fontSize: '1.1rem', color: totalPaymentModeAmount === totalPayingAmount && totalPayingAmount > 0 ? '#10b981' : '#e74c3c'}}>
                        ₹ {totalPaymentModeAmount.toLocaleString()}
                      </td>
                      <td></td>
                    </tr>
                  </tfoot>
                </table>
              </div>

              <div className="sfc-extras-grid">
                
                {/* ── Late Fee Section (EDIT / UPDATE BUTTON Logic) ── */}
                <div className="sfc-form-group">
                  <label style={{display:'flex', alignItems:'center', gap:'8px', flexWrap:'wrap'}}>
                    Late Fee / Fine (₹)
                    {selectedFeeDetails?.isLocked ? (
                      <span style={{fontSize:'0.72rem', background:'#fef3c7', color:'#d97706', padding:'2px 8px', borderRadius:'4px', fontWeight:600, border:'1px solid #fde68a'}}>
                        🔒 Locked
                      </span>
                    ) : selectedFeeDetails?.overdueDays > 0 ? (
                      <span style={{fontSize:'0.72rem', background:'#fef3c7', color:'#d97706', padding:'2px 8px', borderRadius:'4px', fontWeight:600, border:'1px solid #fde68a'}}>
                        ⏰ {selectedFeeDetails.overdueDays} day{selectedFeeDetails.overdueDays !== 1 ? 's' : ''} × ₹{selectedFeeDetails.lateFeePerDay}/day
                      </span>
                    ) : null}
                  </label>
                  <div className="sfc-combined-input-group">
                    <input
                      type="text"
                      inputMode="numeric"
                      className="sfc-combined-input"
                      value={lateFeeInput}
                      onKeyDown={e => {
                        if (['ArrowUp','ArrowDown'].includes(e.key)) e.preventDefault();
                        if (!/[0-9.]/.test(e.key) && !['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight'].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      onChange={e => setLateFeeInput(e.target.value)}
                      disabled={!isLateFeeEditMode || !isBaseFeePaid}
                      min={selectedFeeDetails?.lateFeesPaid || 0}
                      placeholder="Enter amount"
                    />
                    {isLateFeeEditMode ? (
                      <button type="button" className="sfc-combined-btn" style={{color:'#10b981', background:'#f0fdf4', borderLeft:'1px solid #ced4da'}} onClick={handleUpdateLateFeeRow}>✓ Update</button>
                    ) : (
                      <button type="button" className="sfc-combined-btn"
                        style={{color: isBaseFeePaid ? '#3b82f6' : '#94a3b8', background:'#f1f5f9', borderLeft:'1px solid #ced4da', cursor: isBaseFeePaid ? 'pointer' : 'not-allowed'}}
                        title={!isBaseFeePaid ? 'Fill full base fee amount first to edit late fee' : 'Edit late fee'}
                        disabled={!isBaseFeePaid}
                        onClick={() => setIsLateFeeEditMode(true)}>✎ Edit</button>
                    )}
                  </div>
                  {isLateFeeEditMode && (
                    <div style={{ marginTop: '8px', background: '#fffbeb', border: '1px solid #fde68a', borderRadius: '6px', padding: '10px 12px', fontSize: '0.8rem', color: '#92400e', lineHeight: '1.6' }}>
                      ⚠️ <strong>Edit late fee only when:</strong>
                      <ul style={{ margin: '4px 0 0 0', paddingLeft: '18px' }}>
                        <li>Student is paying the <strong>full base fee today</strong>, OR</li>
                        <li>Base fee is <strong>already fully paid</strong></li>
                        <li>Remaining amount is <strong>fully filled</strong> in paying column</li>
                      </ul>
                      If base fee is still pending, this edit will <strong>reset next visit</strong> as late fee keeps increasing daily.
                    </div>
                  )}
                  {selectedFeeDetails?.autoLateFee > 0 && !selectedFeeDetails?.isLocked && (
                    <span style={{fontSize:'0.75rem', color:'#ea580c', marginTop:'4px', display:'block'}}>
                      Auto-calculated: ₹{selectedFeeDetails.autoLateFee.toLocaleString()}
                    </span>
                  )}
                </div>

                <div className="sfc-form-group">
                  <label>
                    {isEditingItems ? 'Edit Reason' : 'Narration'}
                    {(isEditingItems || isLateFeeEditMode || isLateFeeChanged) && <span className="sfc-req"> * Required</span>}
                  </label>
                  <input type="text" className="sfc-input-field"
                    value={isEditingItems ? editNarration : narration}
                    onChange={e => isEditingItems ? setEditNarration(e.target.value) : setNarration(e.target.value)}
                    placeholder={isEditingItems ? 'Reason for fee amount changes (required)' : (isLateFeeEditMode || isLateFeeChanged) ? 'Reason for late fee change (required)' : 'e.g. Cleared pending dues'}
                    style={(isLateFeeEditMode || isLateFeeChanged) && !narration.trim() ? { borderColor: '#ef4444' } : {}}
                  />
                </div>
                
                {/* Summary boxes */}
                <div className="sfc-summary-boxes">
                  <div className="sfc-summary-box paying">
                    <span className="sfc-summary-label">Paying Now</span>
                    <strong className="sfc-summary-val">&#8377; {totalPayingAmount.toLocaleString()}</strong>
                  </div>
                  {(() => {
                    const lateFeePayingNow = Number(payingItems['Late Fee']) || 0;
                    const regularPayingNow = totalPayingAmount - lateFeePayingNow;
                    
                    const remainingRegular = Math.max(0, ((selectedFeeDetails?.totalAmount || 0) - (selectedFeeDetails?.paidAmount || 0)) - regularPayingNow);
                    
                    const alreadyPaidLateFee = selectedFeeDetails?.lateFeesPaid || 0;
                    const remainingLateFee   = Math.max(0, lateFeeCharged - (alreadyPaidLateFee + lateFeePayingNow));
                    
                    const remaining = remainingRegular + remainingLateFee;

                    return (
                      <div className={`sfc-summary-box remaining${remaining === 0 ? ' cleared' : ''}`}>
                        <span className="sfc-summary-label">Remaining Due</span>
                        <strong className="sfc-summary-val">&#8377; {remaining.toLocaleString()}</strong>
                      </div>
                    );
                  })()}
                </div>

              </div>
            </>
          )}

          <div className="sfc-form-actions">
            <button type="button" className="sfc-btn-cancel" onClick={resetForm} disabled={saving}>Cancel</button>
            <button type="submit" className="sfc-btn-confirm" disabled={saving || !formFeeId || (totalPayingAmount <= 0 && !isZeroPaymentAdjustment) || isEditingItems || isAddingParticular}>
              {saving ? 'Processing...' : (isZeroPaymentAdjustment ? 'Update & Waive Fee' : 'Pay & Save')}
            </button>
          </div>
        </form>
      )}

      {/* ── Grouped Tables ── */}
      {loading ? (
        <div style={{ textAlign: 'center', padding: '40px', color: '#64748b' }}>Loading records...</div>
      ) : Object.keys(groupedAllocations).length === 0 ? (
        <div style={{ textAlign: 'center', padding: '40px', color: '#64748b', background: '#fff', borderRadius: '8px' }}>No fee records found.</div>
      ) : (
        <div className="sfc-grouped-container">
          {Object.entries(groupedAllocations).map(([collegeName, allocationsList]) => (
            <div key={collegeName} className="sfc-table-group">
              <h3 className="sfc-group-header">🏫 {collegeName}</h3>
              <div className="sfc-table-wrapper">
                <table className="sfc-table">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th className="sfc-align-left">Student Name</th>
                      <th className="sfc-col-session">Session</th>
                      <th className="sfc-col-batch">Batch</th>
                      <th className="sfc-col-class">Class / Medium</th>
                      <th>Fee Name</th>
                      <th>Total Fee</th>
                      <th>Paid</th>
                      <th className="sfc-col-late">Late Fee</th>
                      <th>Remaining</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {allocationsList.map((alloc, i) => (
                      <React.Fragment key={alloc._id}>
                        <tr className="sfc-main-row">
                          <td>{i + 1}</td>
                          <td className="sfc-align-left">
                            <div className="sfc-name-wrapper" onClick={() => setExpandedRow(expandedRow === alloc._id ? null : alloc._id)}>
                              <span style={{ fontWeight: 600 }}>{alloc.student?.name || '—'}</span>
                              <button className="sfc-expand-btn">
                                {expandedRow === alloc._id ? <FaChevronUp /> : <FaChevronDown />}
                              </button>
                            </div>
                            <div style={{ fontSize: '0.72rem', color: '#94a3b8' }}>{alloc.student?.admissionNo || ''}</div>
                          </td>
                          <td className="sfc-col-session"><span className="sfc-badge-soft">{alloc.session || '—'}</span></td>
                          <td className="sfc-col-batch"><span className="sfc-badge-soft-yellow">{alloc.batch || '—'}</span></td>
                          <td className="sfc-col-class">
                              {alloc.class || '—'}
                              {(alloc.student?.class?.medium || alloc.student?.medium) && <div style={{fontSize:'0.72rem',color:'#7c3aed'}}>{alloc.student?.class?.medium || alloc.student?.medium}</div>}
                            </td>
                          <td style={{ fontWeight: 600, color: '#1e40af' }}>{toTitleCase(alloc.feeName) || '—'}</td>
                          <td>₹ {alloc.totalAmount}</td>
                          <td style={{ color: '#16a34a', fontWeight: 600 }}>₹ {alloc.paidAmount}</td>
                          <td className="sfc-col-late">₹ {alloc.lateFee || 0}</td>
                          <td><strong style={{ color: '#e74c3c' }}>₹ {(alloc.totalRemaining || ((alloc.dueAmount || 0) + (alloc.lateFeeBalance || 0))).toLocaleString()}</strong></td>
                          <td>{getStatusHtml(alloc.dueAmount, alloc.paidAmount)}</td>
                          <td>
                            <div className="sfc-action-btns">
                              {((alloc.totalRemaining || ((alloc.dueAmount || 0) + (alloc.lateFeeBalance || 0))) > 0) && (
                                <button className="sfc-btn-pay" onClick={() => handleCollectClick(alloc._id)}>Pay Now</button>
                              )}
                              {/* 🔥 Fix: Show Log button if paid amount exists OR edit logs exist */}
                              {(alloc.paidAmount > 0 || alloc.feeEditHistory?.length > 0 || alloc.lateFeeEditHistoryWithoutTransaction?.length > 0) && (
                                <button className="sfc-btn-log" onClick={() => openLog(alloc)} title="Payment Log">
                                  <FaHistory /> Log
                                </button>
                              )}
                            </div>
                          </td>
                        </tr>

                        {/* Expanded Row */}
                        {/* Expanded Row */}
                        {expandedRow === alloc._id && (
                          <tr className="sfc-expanded-row">
                            <td colSpan="12">
                              <div className="sfc-expanded-content">
                                
                                <div className="sfc-expanded-grid">
                                  <div className="sfc-exp-item sfc-exp-mobile-only sfc-exp-session"><span className="sfc-exp-label">Session</span><span className="sfc-exp-value">{alloc.session || '—'}</span></div>
                                  <div className="sfc-exp-item sfc-exp-mobile-only sfc-exp-batch"><span className="sfc-exp-label">Batch</span><span className="sfc-exp-value">{alloc.batch || '—'}</span></div>
                                  <div className="sfc-exp-item sfc-exp-mobile-only sfc-exp-class"><span className="sfc-exp-label">Class</span><span className="sfc-exp-value">{alloc.class || '—'}</span></div>
                                  <div className="sfc-exp-item sfc-exp-mobile-only sfc-exp-late"><span className="sfc-exp-label">Late Fee</span><span className="sfc-exp-value">₹ {alloc.lateFee || 0}</span></div>

                                  <div className="sfc-exp-item">
                                    <span className="sfc-exp-label">Father's Name</span>
                                    <span className="sfc-exp-value">{alloc.student?.fatherName || 'N/A'}</span>
                                  </div>
                                  <div className="sfc-exp-item">
                                    <span className="sfc-exp-label">Father's Contact</span>
                                    <span className="sfc-exp-value">{alloc.student?.fatherContact || 'N/A'}</span>
                                  </div>
                                  <div className="sfc-exp-item">
                                    <span className="sfc-exp-label">Contact No</span>
                                    <span className="sfc-exp-value">{alloc.student?.contact || 'N/A'}</span>
                                  </div>
                                  <div className="sfc-exp-item">
                                    <span className="sfc-exp-label">Mother's Name</span>
                                    <span className="sfc-exp-value">{alloc.student?.motherName || 'N/A'}</span>
                                  </div>
                                  <div className="sfc-exp-item">
                                    <span className="sfc-exp-label">Email ID</span>
                                    <span className="sfc-exp-value" style={{ wordBreak: 'break-all' }}>{alloc.student?.email || 'N/A'}</span>
                                  </div>
                                </div>

                                <div className="sfc-exp-particulars-box">
                                  <h4 className="sfc-exp-part-title"><FaListUl style={{marginRight: 8}}/> Paid / Pending Details</h4>
                                  <table className="sfc-exp-part-table">
                                    <thead>
                                      <tr>
                                        <th style={{ textAlign: 'left' }}>Particular</th>
                                        <th style={{ textAlign: 'center' }}>Total</th>
                                        <th style={{ textAlign: 'center' }}>Paid</th>
                                        <th style={{ textAlign: 'center' }}>Balance</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {(alloc.items || []).map((itm, idx) => (
                                        <tr key={idx}>
                                          <td style={{ fontWeight: 600, color: '#1e293b', textAlign: 'left' }}>{itm.type || '—'}</td>
                                          <td style={{ textAlign: 'center' }}>₹ {(itm.amount || 0).toLocaleString()}</td>
                                          <td style={{ color: '#16a34a', textAlign: 'center' }}>₹ {(itm.amountPaid || 0).toLocaleString()}</td>
                                          <td style={{ color: '#e74c3c', fontWeight: 600, textAlign: 'center' }}>₹ {(itm.balance || 0).toLocaleString()}</td>
                                        </tr>
                                      ))}
                                    </tbody>
                                    <tfoot>
                                      <tr>
                                        <td style={{ textAlign: 'left' }}>Total</td>
                                        <td style={{ textAlign: 'center' }}>₹ {(alloc.totalAmount || 0).toLocaleString()}</td>
                                        <td style={{ textAlign: 'center', color: '#16a34a' }}>₹ {(alloc.paidAmount || 0).toLocaleString()}</td>
                                        <td style={{ textAlign: 'center', color: '#e74c3c' }}>₹ {(alloc.dueAmount || 0).toLocaleString()}</td>
                                      </tr>
                                    </tfoot>
                                  </table>
                                </div>

                              </div>
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ))}
        </div>
      )}

    </div>
  );
};

export default FeeCollection;